/**
 * Selects which summary the tier wrap-up screen should render.
 *
 * Real fetched data ALWAYS wins. The hardcoded preview (`debugMock`) is only
 * returned as a fallback when there is no real data AND the local debug toggle
 * is on.
 *
 * This is a named, single-purpose function on purpose. The previous inline form
 *
 *     const tierSummary = (fetchedSummary ?? showDebugMock) ? debugMock : null;
 *
 * relied on `??` binding tighter than `?:`, so a truthy `fetchedSummary`
 * selected `debugMock` and the real summary was silently shadowed — the wrap-up
 * always rendered the mock (frozen session id, played_notes, errors: 0).
 * Keeping the decision here, locked by tierSummaryDisplay.spec.ts, prevents that
 * class of precedence bug from coming back.
 */
export function resolveTierSummaryForDisplay<TSummary>(
  fetchedSummary: TSummary | null,
  showDebugMock: boolean,
  debugMock: TSummary,
): TSummary | null {
  if (fetchedSummary) {
    return fetchedSummary;
  }
  return showDebugMock ? debugMock : null;
}
